/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { CallInboundView } from './call-inbound-view';
import { useLwp } from '../../hooks/use-lwp';

export default function CallInbound(props: {}) {
  const {
    phoneState: { phoneNumber },
    acceptCall, rejectCall 
  } = useLwp();

  return <CallInboundView phoneNumber={phoneNumber} onAnswer={acceptCall} onHangup={rejectCall} />;
}
